<template>
  <div class="p-dashboard">
    Hello World
  </div>
</template>

<script>
// import { VGrid } from '@signable/ui-kit/src/organisms';

export default {
  name: 'dashboard',
  components: {
    // VGrid,
  },
};
</script>
